import axios from 'axios'
import { orderFactory } from './order'

class UserBillFactory {
  async userBill(param: any, id: any) {
    try {
      const url = `/users/${id}/bills`
      const response = await axios.get(url, {
        params: {
          school_year_id: param.school_year_id
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async billUserDetail(bill_id: any, bill_user_id: any) {
    try {
      const url = `/bills/${bill_id}/users/${bill_user_id}`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async updateBillUser(bill_id: any, bill_user_id: any, data: any) {
    try {
      const url = `/bills/${bill_id}/users/${bill_user_id}`
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async saveBillUserNote(bill_id: any, bill_user_id: any, data: any) {
    try {
      const url = `/bills/${bill_id}/users/${bill_user_id}/note`
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async userBillSummary(param: any) {
    try {
      const url = '/bill-users'
      const response = await axios.get(url, {
        params: {
          school_year_id: param.school_year_id,
          class_id: param.class_id,
          bill_type_id: param.bill_type_id,
          limit: param.limit,
          offset: param.offset
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async userBillParam(param: any) {
    try {
      const url = '/bill-users/list'
      const response = await axios.get(url, {
        params: {
          school_year_id: param.school_year_id,
          user_id: param.user_id,
          status: param.status,
          month: param.month,
          order_by: param.order_by,
          order_at: param.order_at,
          keyword: param.keyword,
          spp_bill_id: param.spp_bill_id,
          limit: param.limit,
          offset: param.offset,
          class_id: param.class_id,
          is_published: param.is_published,
          bill_type_id: param.bill_type_id
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async userBillPublish(param: any) {
    try {
      const url = '/bill-users/publishing'
      const response = await axios.put(url, param)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async exportBill(data: any) {
    try {
      const url = '/bill-users/export'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          status: data.status,
          school_year_id: data.school_year_id,
          month: data.month,
          keyword: data.keyword,
          order_by: data.order_by,
          order_at: data.order_at,
          spp_bill_id: data.spp_bill_id,
          user_id: data.user_id,
          class_id: data.class_id,
          is_published: data.is_published,
          bill_type_id: data.bill_type_id
        }
      })
      const headers = response.headers

      let filename = 'Ekspor_Tagihan.xlsx'
      // if content disposition is present
      if (headers['content-disposition']) {
        filename = headers['content-disposition'].split('filename=')[1]
      }

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importBillTxt(data: any) {
    try {
      const url = '/bill-users/import'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async templateDetailImport() {
    try {
      const url = '/bill-users/detail/template'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {}
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Template_Impor_Rincian_Tagihan.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importDetail(data: any) {
    try {
      const url = '/bill-users/detail/import'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async applyImportDetail(data: any) {
    try {
      const url = '/bill-users/detail/import'
      const response = await axios.put(url, { update: data })
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async deleteBillUser(bill_id: any, bill_user_id: any) {
    try {
      const url = `/bills/${bill_id}/users/${bill_user_id}/delete`
      const response = await axios.post(url)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async getRefundDetails(bill_user_id: any) {
    try {
      const url = `/bill-users/${bill_user_id}/refund-details`
      const response = await axios.get(url)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportUserBill(data: any) {
    try {
      const url = '/bill-users/export/recap'
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
        params: {
          school_year_id: data.school_year_id,
          class_id: data.class_id
        }
      })
      const headers = response.headers

      let filename = headers['content-disposition'].split('filename=')[1]

      // remove underscore at first and last character
      filename = filename.substring(1, filename.length - 1)

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const userBillFactory = new UserBillFactory()
